const experiences = {
    monitorOO:{
        jobTitle: 'Monitor',
        company:'Universidade de Brasilia - UnB',
        duration:'2017 - 2019',
        description:'Como consequência do meu bom rendimento acadêmico, fui responsável por auxiliar os professores e tirar dúvidas dos alunos nas seguintes matérias: Orientação a Objetos e Introdução a Engenharia'
    },
    orcestra: {
        jobTitle: 'Assessor de Marketing',
        company:'Empresa Junior de Eng. de Software - Orc\'estra',
        duration:'2017 - 2018/2',
        description:'Atuei em uma equipe de desenvolvimento, o qual pude aprimorar meus conhecimentos em ReactJs e Sass. Além disso, exerci como assessor de marketing trabalhando com produção de conteúdo, planejamento estratégico, manutenção do site empresarial e social media.'
    },
    cascata: {
        jobTitle: 'Professor de Matemática',
        company:'Projeto Cascata',
        duration:'2017',
        description:'Projeto Cascata foi uma iniciativa de estudantes da UnB - FGA para dar aulas de ciências exatas (matemática, física e química) a alunos carentes de ensino público. Participei, como professor de matemática e assessor de conteúdo.'
    },empreendedor:{
        jobTitle: 'Empreendedor',
        company:'Venda de Doces',
        duration:'2016 - 2017',
        description:'Antes de entrar na faculdade, comecei um negócio de vendas de doces, pois quero ter meu próprio negócio e queria começar algo. Nessa jornada no mundo dos negócios, aprendi a complexidade de ter um empreendimento, a dificuldade de lidar com dinheiro, como ser mais comunicativo e empático.'
    },
    oab:{
        jobTitle: 'Menor Aprendiz',
        company:'Conselho Federal da Ordem dos Advodagos do Brasil',
        duration:'2013 - 2015',
        description:'Durante meus dois anos passei por vários setores do Conselho para poder aprender e auxiliar nas atividade. No entanto, meiu maior aprendizado no CFOAB foram as habilidades essenciais em um profissional que adquiri, tais quais como proatividade, responsabilidade e empatia.'
    },
}

export default experiences;